import React from "react";
import OrganisasiContext from "./context/context";
import OrganisasiWrapper from "./ui/OrganisasiWrapper";

const Organisasi = () => {
	return (
		<OrganisasiContext>
			<OrganisasiWrapper />
		</OrganisasiContext>
	);
};

export default Organisasi;
